import { PrismicPageParser } from "../../shared/utils/prismicPageParser"

const HelpContainer = () => {
  const data = JSON.parse(window.prismic_data)
  const pageId = window.pageId

  return (
    <section id="mm-help" className="pageContainer" aria-label="Help page">
      <PrismicPageParser pageData={data} pageId={pageId} />
    </section>
  )
}

export default HelpContainer
